// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --upcare-value-bienveillance: #fed14c;
  --upcare-value-bienveillance-soft: #fff4c7;
  --upcare-value-engagement: #2894d2;
  --upcare-value-engagement-soft: #dff2fc;
  --upcare-value-faire-equipe: #e71873;
  --upcare-value-faire-equipe-soft: #fde2ee;
  --upcare-value-respect: #2fac68;
  --upcare-value-respect-soft: #def5e8;

  --upcare-value-track: #e8eaec;
  --upcare-value-text: #263746;
}

[aria-label="Données des services du pôle"] button > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--upcare-value-faire-equipe);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/values-theme.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kCAAkC;EAClC,uCAAuC;EACvC,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;;EAEpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[":root {\r\n  --upcare-value-bienveillance: #fed14c;\r\n  --upcare-value-bienveillance-soft: #fff4c7;\r\n  --upcare-value-engagement: #2894d2;\r\n  --upcare-value-engagement-soft: #dff2fc;\r\n  --upcare-value-faire-equipe: #e71873;\r\n  --upcare-value-faire-equipe-soft: #fde2ee;\r\n  --upcare-value-respect: #2fac68;\r\n  --upcare-value-respect-soft: #def5e8;\r\n\r\n  --upcare-value-track: #e8eaec;\r\n  --upcare-value-text: #263746;\r\n}\r\n\r\n[aria-label=\"Données des services du pôle\"] button > span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  margin-left: 6px;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: var(--upcare-value-faire-equipe);\r\n  color: #fff;\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
